import { Heading } from '@chakra-ui/react';

export function PriceAndUnitPrice(props: { displayPrice: string | undefined; displayPriceUnits: string | undefined }) {
  return (
    <Heading as='p' color='blue.800' fontWeight='500' size='marketing-4xl'>
      {props.displayPrice}{' '}
      <Heading as='span' size='marketing-lg'>
        {props.displayPriceUnits}
      </Heading>
    </Heading>
  );
}
